import { Breadcrumb, Card, Col, Popconfirm, Row, Tabs } from 'antd'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import EmailCont from '../../../../components/Common/Email/EmailCont'
import History from '../../../../components/Common/History'
import MRNLinesCont from '../../../../components/HSEQ/MRN/Lines/MRNLinesCont'
import MRNForm from '../../../../components/HSEQ/MRN/MRNForm'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CodeIcon from '../../../../elements/CodeIcon'
import CustomSpin from '../../../../elements/CustomSpin'
import IconText from '../../../../elements/IconText'
import LinkHeader from '../../../../elements/LinkHeader'
import Status from '../../../../elements/Status'
import _, { get } from 'lodash'
import Authentication from '../../../../modules/Authentication'
import { idMaker, strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'
import { streamUrl } from '../../../../variables'

const ids = idMaker()

AddMRN.propTypes = {}
const auth = new Authentication()

function AddMRN(props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    mrn,
    remove,
    removing,
    isUpdatable,
    actions,
    handleActions,
    onShowEmail,
    isApproved,
    isNew,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
  } = props

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )
  const Operations = ({ mrn, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    if (ops.length > 0 && !isApproved) {
      ops.push(
        <a target={'_blank'} href={`${streamUrl}pdf/${get(mrn, '_id')}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'} />
        </a>
      )
    }

    if (ops.length > 0 && isApproved) {
      ops.push(
        <a onClick={onShowEmail}>
          <IconText text={'Send Email'} type={'mail'} />
        </a>
      )
    }

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  return (
    <CustomSpin spinning={fetching}>
      {get(mrn, 'deliveryOrders', []).map((DO) => (
        <LinkHeader
          title={'Material Release Notes'}
          type={'Delivery Order'}
          link={{
            pathname: `/purchasing/delivery/${_.get(DO, '_id', '').replace('deliveryOrder/', '')}/update`,
          }}
          code={DO.code || ''}
          name={DO.title || ''}
          visible={true}
        />
      ))}
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>HSEQ</Breadcrumb.Item>
            <Breadcrumb.Item href="#/hseq/mrn/list">Material Release Notes</Breadcrumb.Item>
            <Breadcrumb.Item>{isNew ? 'New MRN' : mrn.code}</Breadcrumb.Item>
          </Breadcrumb>
          {isNew && <h2 className={style.title}>New Material Release Note</h2>}
          {!isNew && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <CodeIcon
                    code={`${strVal(mrn, 'code')}.${('00' + strVal(mrn, 'revision')).slice(-2)}`}
                    title={'MRN Code'}
                  />
                  <Status value={strVal(mrn, 'status')} />
                  <Operations style={{ marginTop: '10px' }} mrn={mrn} status={strVal(mrn, 'status')} />
                </h3>
              </Col>
              <RefreshButton onClick={fetch} />
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <EmailCont
          key={ids.next().value}
          visible={visibleEmail}
          onCancel={onCancelEmail}
          template={emailTemplate}
          email={emailDetails}
          files={emailFiles}
          lines={emailLines}
        />
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <MRNForm ref={formRef} {...props} />
            {isUpdatable && <SubmitButton />}
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab={'Lines'} key="#lines">
            <MRNLinesCont {...{ isUpdatable, mrn }} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Documents" key="files">
            <Documents key={mrn._rev} editable={true} footer={false} category={false} email={true} owner={mrn} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="History" key="history">
            <History owner={mrn} key={mrn._rev} isArray={true} />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddMRN
